<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div *ngIf="requestServ.LogingLoading" class="preloader">
  <div class="spinner2 text-center">
    <img class="mb-2" src="assets/images/Logo.png" alt="" height="45" width="250" />
    <!-- Desarrollado por <a target="blank" href="https://www.saftelmah.com.ec/empresa/">
            <strong style="color: black;">ZAMBTECHNOLOGY S.A</strong></a> <br> -->
    <div class=" "></div>
  </div>
</div>
<div id="main-wrapper" [ngClass]="{
    defaultdark: color == 'defaultdark',
    greendark: color == 'greendark',
    reddark: color == 'reddark',
    bluedark: color == 'bluedark',
    purpledark: color == 'purpledark',
    megnadark: color == 'megnadark',
    default: color == 'default',
    green: color == 'green',
    red: color == 'red',
    blue: color == 'blue',
    purple: color == 'purple',
    megna: color == 'megna',
    'mini-sidebar': sidebarService.showMinisidebar,
    'mobile-open': isMobile && isMobileOpen,
    'dark-theme': themeService.isDark,
    'rtl-theme': showRtl
  }">
  <!-- ============================================================== -->
  <!-- Topbar header - style you can find in pages.scss -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar" (click)="$event.stopPropagation()">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" [perfectScrollbar]="config">
      <app-sidebar></app-sidebar>
    </div>
    <!-- End Sidebar scroll-->
  </aside>

  <!-- Mobile floating toggle (visible only on mobile) -->
  <button type="button" class="mobile-menu-fab" (click)="toggleMobileMenu()"
    [attr.aria-label]="isMobileOpen ? 'Cerrar menú' : 'Abrir menú'">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.8" />
      <path d="M9 4v16" stroke="currentColor" stroke-width="1.8" />
    </svg>
  </button>

  <!-- Mobile backdrop -->
  <div class="mobile-backdrop" *ngIf="isMobile && isMobileOpen" (click)="closeSidebar()"></div>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Page wrapper  -->
  <!-- ============================================================== -->
  <div class="page-wrapper" (click)="closeSidebar()">
    <app-breadcrumb></app-breadcrumb>

    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <app-aviso-plataforma modo="sistema"></app-aviso-plataforma>
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="mt-0">
        <router-outlet></router-outlet>
      </div>
      <!-- ============================================================== -->
      <!-- End Start Page Content -->
      <!-- ============================================================== -->
      <!-- ============================================================== -->
      <!-- Setting Right sidebar -->
      <!-- ============================================================== -->

      <!-- ============================================================== -->
      <!-- End Right sidebar -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->
  <app-notificaciones-flotantes></app-notificaciones-flotantes>
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <!-- <footer class="footer ">
        © 2021 DESARROLLADO POR ZAMBTECHNOLOGY S.A

    </footer> -->
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
</div>
